// 存放mock接口数据
export default {
  ret: 0,
  msg: '',
  data: {
    test: '111',
  },
};
